import ROLE_PERMISSIONg from '@/constants/index'

export default {
  /**
   * Determine whether user has permissions to access a certain feature
   * @param {String} key feature key
   * @param {'check all' | 'check once'} type check all: all keys must be true; check once: atleast one key must be true 
   */
  checkAccess(key='', type = 'check all') {
    if (Array.isArray(key)) {
      for (const _key of key) {
        if (!this.checkAccess(_key) && type === 'check all') {
          return false;
        }
        if (this.checkAccess(_key) && type === 'check once') {
          return true;
        }
      }
      return type === 'check all';
    } else {
      const user = JSON.parse(localStorage.getItem('user'));
      const isSuperAdmin = user.role.name.toLowerCase() === 'super admin' && !user.role.is_deletable;
      const hasAccess = Array.isArray(user.role.accesses) && user.role.accesses.some(access => {
        return access.permission?.route_label?.toLowerCase() === key.toLowerCase();
      });
      return isSuperAdmin || hasAccess;
    }
  },
}